import React, { ReactElement, ReactNode } from 'react';
import Icon from '@components/Icon';
import IconButton from '@components/IconButton';

interface GenericPopupProps {
  isOpen: boolean;
  onClose?: () => void;
  headerContent: ReactNode;
  bodyContent: ReactNode;
}

const GenericPopup = ({
  isOpen,
  headerContent,
  bodyContent,
  onClose,
}: GenericPopupProps): ReactElement | null => {
  if (!isOpen) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 z-popup overflow-auto flex bg-modalBackground w-full h-full"
      data-testid="generic-popup"
    >
      <div className="relative bg-white w-full max-w-[510px] m-auto flex-col flex p-3 rounded-xl">
        <div className="flex flex-wrap content-center text-body">
          <div className="text-left w-1/2 text-heading4 font-semibold flex flex-wrap items-center">
            {headerContent}
          </div>
          {onClose && (
            <div className="w-1/2 flex flex-wrap justify-end">
              <IconButton
                onClick={onClose}
                data-testid="generic-popup-close-button"
              >
                <Icon.Close className="text-heading4 font-semibold" />
              </IconButton>
            </div>
          )}
        </div>
        <div className="text-heading6 font-normal text-left mt-2">
          {bodyContent}
        </div>
      </div>
    </div>
  );
};

export default GenericPopup;
